import { domel } from '@easydata/ui';
import { i18n, QueryChangePart } from '@easyquery/core';
import { AggrSettingsRenderer } from '../widgets/renderers/aggr_settings/aggr_settings_renderer';
var AggrSettingsDialog = /** @class */ (function () {
    function AggrSettingsDialog(context) {
        this.context = context;
        this.promise = null;
    }
    AggrSettingsDialog.prototype.show = function (query) {
        var _this = this;
        var initQuery = query || this.context.getQuery();
        // copy query to prevent changes
        this.query = this.context.createQuery();
        this.query.loadFromData(initQuery.toJSONData());
        // to rewrite with returning new aggrsettigns 
        // structure instead of apply on submit
        if (!this.promise) {
            this.promise = new Promise(function (resolve, reject) {
                var ds = _this.context.getServices().getDialogService();
                _this.body = _this.renderBody();
                var dlg = ds.open({
                    title: i18n.getText('AggrSettings', 'AggrDialogTitle'),
                    body: _this.body,
                    onSubmit: function () {
                        if (_this.query.enableAggregation && !_this.renderer.isValid())
                            return false;
                        initQuery.enableAggregation = _this.query.enableAggregation;
                        if (initQuery.enableAggregation) {
                            initQuery.useAggregation(function (settings) {
                                var s = _this.renderer.getSettings();
                                settings.loadFromData(s.saveToData());
                            });
                        }
                        initQuery.fireChangedEvent({
                            part: QueryChangePart.Aggregation,
                            wasModified: false
                        });
                        resolve();
                        return true;
                    },
                    onCancel: function () {
                        resolve();
                    }
                });
                _this.renderer = new AggrSettingsRenderer({
                    slot: _this.body.querySelector('#AggrSettingsComponent'),
                    query: _this.query,
                    onChanged: function () {
                        dlg.clearAlert();
                        var isValid = _this.renderer.isValid();
                        if (!isValid) {
                            var error = _this.renderer.getValidationMessage();
                            dlg.showAlert(error, 'warning');
                        }
                        var btn = dlg.getRootElement()
                            .querySelector('.kfrm-button.is-info');
                        btn.disabled = !isValid && _this.query.enableAggregation;
                    }
                });
                if (_this.query.enableAggregation) {
                    _this.renderer.render();
                }
            });
        }
        return this.promise.catch(function (e) { return console.error(e); })
            .finally(function () { return _this.promise = null; });
    };
    AggrSettingsDialog.prototype.renderBody = function () {
        var _this = this;
        var b = domel('div')
            .addChild('div', function (b) { return b
            .addClass("eqjs-as-enableaggr")
            .addChild('label', function (b) { return b
            .addClass('eqjs-ctrl-switch')
            .addChild('input', function (b) {
            b.attr('type', 'checkbox');
            if (_this.query.enableAggregation) {
                b.attr('checked', '');
            }
            b.on('change', _this.enableAggrCheckBoxChangeHandler.bind(_this));
        })
            .addChild('span', function (b) { return b
            .addClass('slider round'); })
            .addChild('span', function (b) { return b
            .addClass('switch-text')
            .addText(i18n.getText('AggrSettings', 'EnableAggrLabel')); }); }); })
            .addChild('div', function (b) { return b
            .id('AggrSettingsComponent'); });
        return b.toDOM();
    };
    AggrSettingsDialog.prototype.enableAggrCheckBoxChangeHandler = function (e) {
        this.query.enableAggregation = !this.query.enableAggregation;
        this.body.querySelector('#AggrSettingsComponent').innerHTML = '';
        if (this.query.enableAggregation) {
            this.renderer.render();
        }
        else {
            var btn = this.body ? this.body.closest('.kdlg-modal').querySelector('footer .kfrm-button.is-info') : null;
            if (btn) {
                btn.disabled = false;
            }
        }
    };
    return AggrSettingsDialog;
}());
export { AggrSettingsDialog };
//# sourceMappingURL=aggr_settings_dialog.js.map